/* ──────────────────────────────────────────────────────────────────────────
 * Apollo Bearing Index — request-a-quote dialog (IFX.rfq)
 * assets/interchange-rfq.js
 *
 * Native <dialog>.showModal() with a manual focus-trap fallback. Reusable
 * indefinitely: the form is never innerHTML-replaced. POSTs JSON to /api/rfq
 * with the honeypot (name="website") and the startedAt timing signal.
 * ───────────────────────────────────────────────────────────────────────── */
(function () {
  "use strict";
  var IFX = window.IFX;
  if (!IFX || IFX.rfq) return;

  var modal = null, form = null, errorEl = null, opener = null, fallbackOpen = false, supportsDialog = false, app = null;

  function focusables() {
    if (!modal) return [];
    var sel = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])';
    return Array.from(modal.querySelectorAll(sel)).filter(function (el) { return el.tabIndex >= 0 && el.offsetWidth + el.offsetHeight > 0; });
  }
  function trapKeydown(e) {
    if (!fallbackOpen) return;
    if (e.key === "Escape") { e.preventDefault(); close(); return; }
    if (e.key !== "Tab") return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function restoreFocus() {
    if (opener && typeof opener.focus === "function" && document.contains(opener)) opener.focus();
    opener = null;
  }
  function setError(message) {
    if (!errorEl) return;
    errorEl.textContent = message || "";
    errorEl.hidden = !message;
  }

  function open(partNumber, brand, context) {
    if (!modal || !form) return;
    opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    var pnField = form.querySelector('input[name="requestedPn"]');
    var brandField = form.querySelector('input[name="requestedBrand"]');
    var startedField = form.querySelector('input[name="startedAt"]');
    if (pnField) pnField.value = partNumber || "";
    if (brandField) brandField.value = brand || "";
    if (startedField) startedField.value = String(Date.now());
    var summary = form.querySelector(".ifx-rfq__summary");
    if (summary) {
      summary.innerHTML = partNumber
        ? '<span class="ifx-rfq__for">Quote for</span> <span class="ifx-brand">' + IFX.escapeHtml(IFX.brandName(brand)) + '</span> <span class="ifx-pn">' + IFX.escapeHtml(partNumber) + "</span>"
          + (context ? '<span class="ifx-rfq__ctx">' + IFX.escapeHtml(context) + "</span>" : "")
        : '<span class="ifx-rfq__for">Quote for a part we have not indexed yet. Tell us what you need.</span>';
    }
    setError(null);
    if (supportsDialog) modal.showModal();
    else {
      modal.setAttribute("open", "");
      modal.setAttribute("role", "dialog");
      modal.setAttribute("aria-modal", "true");
      fallbackOpen = true;
      document.addEventListener("keydown", trapKeydown, true);
    }
    IFX.track("ifx_rfq_open", { pn: partNumber || "" });
    var nameField = form.querySelector('input[name="name"]');
    if (nameField) setTimeout(function () { nameField.focus(); }, 30);
  }

  function close() {
    if (!modal) return;
    if (supportsDialog) { if (modal.open) modal.close(); }
    else {
      modal.removeAttribute("open");
      fallbackOpen = false;
      document.removeEventListener("keydown", trapKeydown, true);
      restoreFocus();
    }
  }

  function init(application) {
    app = application;
    modal = app.root.querySelector('.ifx-dialog[data-modal="rfq"]');
    form = modal ? modal.querySelector(".ifx-rfq__form") : null;
    errorEl = modal ? modal.querySelector(".ifx-dialog__error") : null;
    supportsDialog = !!(modal && typeof modal.showModal === "function");
    if (!modal || !form) return;

    modal.querySelectorAll("[data-close]").forEach(function (el) { el.addEventListener("click", close); });
    modal.addEventListener("click", function (e) { if (e.target === modal) close(); });
    if (supportsDialog) modal.addEventListener("close", restoreFocus);

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      setError(null);
      var fd = new FormData(form);
      var name = String(fd.get("name") || "").trim();
      var email = String(fd.get("email") || "").trim();
      if (!name) return setError("Add your name so we know who to reply to.");
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return setError("Enter a valid email address so we can send the quote.");
      var body = {
        name: name,
        email: email,
        requestedPn: String(fd.get("requestedPn") || ""),
        qty: Math.max(1, Number(fd.get("qty")) || 1),
        website: String(fd.get("website") == null ? "" : fd.get("website")),
        startedAt: Number(fd.get("startedAt")) || Date.now(),
      };
      var brand = String(fd.get("requestedBrand") || "").trim();
      if (brand) body.requestedBrand = brand;
      var phone = String(fd.get("phone") || "").trim();
      if (phone) body.phone = phone;
      var notes = String(fd.get("notes") || "").trim();
      if (notes) body.notes = notes;

      var submitBtn = form.querySelector('button[type="submit"]');
      var originalLabel = submitBtn ? submitBtn.textContent : "";
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Sending…"; }
      IFX.api.rfq(body).then(function (data) {
        if (!data || data.ok === false) {
          var err = new Error("RFQ failed");
          err.userMessage = data && data.message ? String(data.message) : "";
          throw err;
        }
        close();
        IFX.showToast("Quote request sent. Reference " + (data.reference || data.id || "pending") + ".", { tone: "ok" });
        form.reset();
        IFX.track("ifx_rfq_submit", { ok: true });
      }).catch(function (err) {
        console.error("[interchange] rfq submit error", err);
        setError(err && err.userMessage ? err.userMessage : "We couldn't send your request. Try again, or email sales@apollousa.com directly.");
        IFX.track("ifx_rfq_submit", { ok: false });
      }).then(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalLabel || "Send request"; }
      });
    });
  }

  var rfq = { init: init, open: open, close: close };
  IFX.rfq = rfq;
  IFX.define("rfq", rfq);
})();
